import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import { useLanguage } from "../../contexts/LanguageContext";

interface Section {
  number: string;
  heading: string;
  content: (string | string[])[];
}

const DE_SECTIONS: Section[] = [
  {
    number: "1.",
    heading: "Verantwortlicher",
    content: [
      "Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website ist:",
      [
        "TOP Buchhaltungsservice UG (haftungsbeschränkt)",
        "Stuttgartstraße 15–17",
        "44143 Dortmund",
        "Deutschland",
        "Telefon: +49 231-53479212",
        "E-Mail: info@top-bhs.de",
      ],
    ],
  },
  {
    number: "2.",
    heading: "Allgemeine Hinweise zur Datenverarbeitung",
    content: [
      "Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung unserer Website, zur Bearbeitung von Anfragen, zur Vertragsanbahnung, zur Vertragsdurchführung sowie zur Erfüllung rechtlicher Pflichten erforderlich ist.",
    ],
  },
  {
    number: "3.",
    heading: "Aufruf der Website / Server-Logfiles",
    content: [
      "Beim Aufruf unserer Website werden durch den Hosting-Provider technisch erforderliche Daten verarbeitet. Hierzu können insbesondere gehören:",
      [
        "• IP-Adresse",
        "• Datum und Uhrzeit des Abrufs",
        "• aufgerufene Seite bzw. Datei",
        "• Referrer-URL",
        "• Browsertyp und Browserversion",
        "• verwendetes Betriebssystem",
        "• Zugriffsstatus / HTTP-Statuscode",
        "• übertragene Datenmenge",
      ],
      "Die Verarbeitung erfolgt, um die Website technisch bereitzustellen, die Stabilität und Sicherheit zu gewährleisten sowie Fehler zu analysieren.",
      "Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO — Berechtigtes Interesse: sichere, stabile und funktionsfähige Bereitstellung der Website.",
      "Speicherdauer: Server-Logdaten werden grundsätzlich nur für einen kurzen Zeitraum gespeichert und anschließend gelöscht, sofern keine weitere Aufbewahrung zu Beweiszwecken oder zur Abwehr von Missbrauch erforderlich ist.",
    ],
  },
  {
    number: "4.",
    heading: "Kontaktaufnahme per E-Mail, Telefon oder Kontaktformular",
    content: [
      "Wenn Sie uns per E-Mail, telefonisch oder über ein Kontaktformular kontaktieren, verarbeiten wir die von Ihnen mitgeteilten Daten, insbesondere:",
      [
        "• Name",
        "• Kontaktdaten",
        "• Firmenangaben",
        "• Inhalt Ihrer Anfrage",
        "• Zeitpunkt der Anfrage",
      ],
      "Die Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage sowie zur Anbahnung oder Durchführung eines Vertragsverhältnisses.",
      "Rechtsgrundlage:",
      [
        "• Art. 6 Abs. 1 lit. b DSGVO, soweit die Anfrage auf den Abschluss oder die Durchführung eines Vertrags gerichtet ist",
        "• Art. 6 Abs. 1 lit. f DSGVO, soweit die Anfrage sonstiger Natur ist",
      ],
      "Speicherdauer: Wir speichern Anfragen grundsätzlich bis zur abschließenden Bearbeitung. Soweit sich daraus ein Vertragsverhältnis ergibt oder handels- bzw. steuerrechtliche Aufbewahrungspflichten bestehen, erfolgt die Speicherung zusätzlich im Rahmen der gesetzlichen Fristen.",
    ],
  },
  {
    number: "5.",
    heading: "Cookies und ähnliche Technologien",
    content: [
      "Unsere Website verwendet technisch erforderliche Cookies und ähnliche Technologien, soweit dies für den sicheren und funktionsfähigen Betrieb der Website notwendig ist.",
      "Rechtsgrundlage:",
      [
        "• § 25 Abs. 2 Nr. 2 TDDDG",
        "• Art. 6 Abs. 1 lit. f DSGVO",
      ],
      "Soweit wir künftig zusätzliche, nicht technisch erforderliche Cookies oder vergleichbare Technologien einsetzen, erfolgt dies ausschließlich auf Grundlage Ihrer Einwilligung.",
      "Rechtsgrundlage in diesem Fall:",
      [
        "• § 25 Abs. 1 TDDDG",
        "• Art. 6 Abs. 1 lit. a DSGVO",
      ],
    ],
  },
  {
    number: "6.",
    heading: "Empfänger personenbezogener Daten",
    content: [
      "Wir setzen im Rahmen der gesetzlichen Vorgaben Dienstleister ein, insbesondere für Hosting, IT-Betreuung und Website-Betrieb. Diese Dienstleister verarbeiten Daten nur auf unsere Weisung und auf Grundlage entsprechender Verträge zur Auftragsverarbeitung, soweit dies datenschutzrechtlich erforderlich ist.",
      "Darüber hinaus übermitteln wir personenbezogene Daten nur dann an Dritte, wenn:",
      [
        "• dies zur Vertragsdurchführung erforderlich ist,",
        "• wir rechtlich dazu verpflichtet sind oder",
        "• Sie eingewilligt haben.",
      ],
    ],
  },
  {
    number: "7.",
    heading: "Drittlandübermittlungen",
    content: [
      "Eine Übermittlung personenbezogener Daten in Staaten außerhalb der Europäischen Union oder des Europäischen Wirtschaftsraums erfolgt nur, wenn dies gesetzlich zulässig ist oder Sie eingewilligt haben.",
    ],
  },
  {
    number: "8.",
    heading: "Speicherdauer",
    content: [
      "Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen Zwecke erforderlich ist. Darüber hinaus speichern wir Daten, soweit gesetzliche Aufbewahrungspflichten bestehen, insbesondere nach dem Handelsgesetzbuch und der Abgabenordnung.",
    ],
  },
  {
    number: "9.",
    heading: "Ihre Rechte",
    content: [
      "Sie haben nach der DSGVO insbesondere folgende Rechte:",
      [
        "• Recht auf Auskunft nach Art. 15 DSGVO",
        "• Recht auf Berichtigung nach Art. 16 DSGVO",
        "• Recht auf Löschung nach Art. 17 DSGVO",
        "• Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO",
        "• Recht auf Datenübertragbarkeit nach Art. 20 DSGVO",
        "• Recht auf Widerspruch nach Art. 21 DSGVO",
        "• Recht auf Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft",
        "• Recht auf Beschwerde bei einer Datenschutzaufsichtsbehörde",
      ],
      "Zuständige Aufsichtsbehörde für Nordrhein-Westfalen ist:",
      [
        "Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen",
        "Kavalleriestraße 2–4",
        "40213 Düsseldorf",
        "Telefon: +49 211 38424-0",
        "E-Mail: poststelle@ldi.nrw.de",
      ],
    ],
  },
  {
    number: "10.",
    heading: "Pflicht zur Bereitstellung von Daten",
    content: [
      "Die Bereitstellung personenbezogener Daten ist weder gesetzlich noch vertraglich vorgeschrieben. Ohne bestimmte Angaben kann es jedoch sein, dass wir Ihre Anfrage nicht bearbeiten oder einen Vertrag nicht durchführen können.",
    ],
  },
  {
    number: "11.",
    heading: "Automatisierte Entscheidungsfindung",
    content: [
      "Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22 DSGVO findet nicht statt.",
    ],
  },
  {
    number: "12.",
    heading: "Aktualität und Änderung dieser Datenschutzerklärung",
    content: [
      "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn dies aufgrund rechtlicher, technischer oder organisatorischer Änderungen erforderlich wird.",
    ],
  },
];

const EN_SECTIONS: Section[] = [
  {
    number: "1.",
    heading: "Controller",
    content: [
      "The controller responsible for processing personal data on this website is:",
      [
        "TOP Buchhaltungsservice UG (haftungsbeschränkt)",
        "Stuttgartstraße 15–17",
        "44143 Dortmund",
        "Germany",
        "Phone: +49 231-53479212",
        "Email: info@top-bhs.de",
      ],
    ],
  },
  {
    number: "2.",
    heading: "General Information on Data Processing",
    content: [
      "We process personal data only to the extent necessary to provide our website, handle enquiries, initiate and perform contracts, and fulfil legal obligations.",
    ],
  },
  {
    number: "3.",
    heading: "Website Access / Server Log Files",
    content: [
      "When you visit our website, our hosting provider processes technically required data, including:",
      [
        "• IP address",
        "• Date and time of access",
        "• Page or file accessed",
        "• Referrer URL",
        "• Browser type and version",
        "• Operating system",
        "• Access status / HTTP status code",
        "• Data volume transferred",
      ],
      "Processing serves to provide the website technically, ensure stability and security, and analyse errors.",
      "Legal basis: Art. 6(1)(f) GDPR — Legitimate interest: secure, stable and functional operation of the website.",
      "Retention period: Server log data is generally stored for a short period only and then deleted, unless further retention is required for evidentiary purposes or to prevent misuse.",
    ],
  },
  {
    number: "4.",
    heading: "Contact via Email, Phone or Contact Form",
    content: [
      "When you contact us by email, phone or via a contact form, we process the data you provide, in particular:",
      ["• Name", "• Contact details", "• Company information", "• Content of your enquiry", "• Time of enquiry"],
      "Processing serves to handle your enquiry and to initiate or perform a contract.",
      "Legal basis:",
      [
        "• Art. 6(1)(b) GDPR where the enquiry relates to a contract",
        "• Art. 6(1)(f) GDPR for all other enquiries",
      ],
      "Retention period: We retain enquiries until final processing. Where a contract arises or statutory retention obligations apply, data is stored for the statutory periods.",
    ],
  },
  {
    number: "5.",
    heading: "Cookies and Similar Technologies",
    content: [
      "Our website uses technically necessary cookies and similar technologies to the extent required for secure and functional operation.",
      "Legal basis:",
      ["• § 25(2) No. 2 TDDDG", "• Art. 6(1)(f) GDPR"],
      "If we use additional non-essential cookies in future, this will only be on the basis of your consent.",
      "Legal basis in that case:",
      ["• § 25(1) TDDDG", "• Art. 6(1)(a) GDPR"],
    ],
  },
  {
    number: "6.",
    heading: "Recipients of Personal Data",
    content: [
      "We engage service providers, in particular for hosting, IT support and website operation. These providers process data solely on our instructions and under data processing agreements.",
      "We only transfer personal data to third parties where:",
      [
        "• this is necessary for contract performance,",
        "• we are legally obliged to do so, or",
        "• you have consented.",
      ],
    ],
  },
  {
    number: "7.",
    heading: "Transfers to Third Countries",
    content: [
      "Personal data is only transferred to countries outside the EU or EEA where this is legally permissible or you have consented.",
    ],
  },
  {
    number: "8.",
    heading: "Retention Period",
    content: [
      "We store personal data only as long as necessary for the respective purposes, and additionally where statutory retention obligations apply under the German Commercial Code or Fiscal Code.",
    ],
  },
  {
    number: "9.",
    heading: "Your Rights",
    content: [
      "Under the GDPR you have in particular the following rights:",
      [
        "• Right of access (Art. 15 GDPR)",
        "• Right to rectification (Art. 16 GDPR)",
        "• Right to erasure (Art. 17 GDPR)",
        "• Right to restriction of processing (Art. 18 GDPR)",
        "• Right to data portability (Art. 20 GDPR)",
        "• Right to object (Art. 21 GDPR)",
        "• Right to withdraw consent with future effect",
        "• Right to lodge a complaint with a supervisory authority",
      ],
      "The competent supervisory authority for North Rhine-Westphalia is:",
      [
        "Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen",
        "Kavalleriestraße 2–4, 40213 Düsseldorf",
        "Phone: +49 211 38424-0",
        "Email: poststelle@ldi.nrw.de",
      ],
    ],
  },
  {
    number: "10.",
    heading: "Obligation to Provide Data",
    content: [
      "The provision of personal data is neither legally nor contractually required. However, without certain information we may be unable to process your enquiry or perform a contract.",
    ],
  },
  {
    number: "11.",
    heading: "Automated Decision-Making",
    content: ["Automated decision-making including profiling within the meaning of Art. 22 GDPR does not take place."],
  },
  {
    number: "12.",
    heading: "Updates to this Privacy Policy",
    content: ["We reserve the right to update this privacy policy where required due to legal, technical or organisational changes."],
  },
];

const AR_SECTIONS: Section[] = [
  {
    number: "1.",
    heading: "المسؤول عن معالجة البيانات",
    content: [
      "الجهة المسؤولة عن معالجة البيانات الشخصية على هذا الموقع هي:",
      [
        "TOP Buchhaltungsservice UG (haftungsbeschränkt)",
        "Stuttgartstraße 15–17",
        "44143 Dortmund",
        "Deutschland",
        "الهاتف: 53479212-231 49+",
        "البريد الإلكتروني: info@top-bhs.de",
      ],
    ],
  },
  {
    number: "2.",
    heading: "ملاحظات عامة حول معالجة البيانات",
    content: [
      "نقوم بمعالجة البيانات الشخصية فقط بالقدر اللازم لتقديم خدمات موقعنا، ومعالجة الاستفسارات، وإبرام العقود وتنفيذها، وأداء الالتزامات القانونية.",
    ],
  },
  {
    number: "3.",
    heading: "زيارة الموقع / ملفات سجل الخادم",
    content: [
      "عند زيارة موقعنا، يقوم مزود الاستضافة بمعالجة البيانات التقنية الضرورية، وتشمل:",
      ["• عنوان IP", "• تاريخ ووقت الوصول", "• الصفحة أو الملف الذي تم الوصول إليه", "• URL المُحيل", "• نوع وإصدار المتصفح", "• نظام التشغيل المستخدم", "• حالة الوصول / كود HTTP", "• حجم البيانات المنقولة"],
      "تتم المعالجة لتوفير الموقع تقنياً وضمان الاستقرار والأمان وتحليل الأخطاء.",
      "الأساس القانوني: المادة 6 الفقرة 1 حرف و من اللائحة العامة لحماية البيانات — المصلحة المشروعة: تشغيل الموقع بشكل آمن ومستقر.",
      "مدة الاحتفاظ: يتم حذف بيانات سجل الخادم بعد فترة قصيرة، ما لم تكن هناك حاجة للاحتفاظ بها لأغراض الإثبات أو منع إساءة الاستخدام.",
    ],
  },
  {
    number: "4.",
    heading: "التواصل عبر البريد الإلكتروني أو الهاتف أو نموذج الاتصال",
    content: [
      "عند تواصلكم معنا، نقوم بمعالجة البيانات التي تقدمونها، وتشمل على وجه الخصوص:",
      ["• الاسم", "• بيانات الاتصال", "• بيانات الشركة", "• محتوى استفساركم", "• وقت الاستفسار"],
      "تتم المعالجة لمعالجة استفساركم وإبرام العقد أو تنفيذه.",
      "الأساس القانوني:",
      ["• المادة 6/1/ب من اللائحة العامة إذا كان الاستفسار يتعلق بعقد", "• المادة 6/1/و من اللائحة العامة لسائر الاستفسارات"],
      "مدة التخزين: نحتفظ بالاستفسارات حتى اكتمال معالجتها، وفي حالة الالتزامات القانونية يتم الاحتفاظ بها للمدة القانونية المحددة.",
    ],
  },
  {
    number: "5.",
    heading: "ملفات تعريف الارتباط والتقنيات المماثلة",
    content: [
      "يستخدم موقعنا ملفات تعريف الارتباط التقنية الضرورية فقط لضمان التشغيل الآمن والوظيفي للموقع.",
      "الأساس القانوني:",
      ["• § 25 الفقرة 2 رقم 2 TDDDG", "• المادة 6/1/و من اللائحة العامة"],
      "في حال استخدام ملفات تعريف إضافية غير ضرورية تقنياً في المستقبل، سيكون ذلك بناءً على موافقتكم فقط.",
      "الأساس القانوني في هذه الحالة:",
      ["• § 25 الفقرة 1 TDDDG", "• المادة 6/1/أ من اللائحة العامة"],
    ],
  },
  {
    number: "6.",
    heading: "مستلمو البيانات الشخصية",
    content: [
      "نستعين بمزودي خدمات للاستضافة وتشغيل الموقع. يعالج هؤلاء البيانات فقط وفق تعليماتنا وبموجب عقود معالجة البيانات.",
      "لا نقوم بنقل البيانات إلى أطراف ثالثة إلا في الحالات التالية:",
      ["• إذا كان ذلك ضرورياً لتنفيذ العقد،", "• إذا كنا ملزمين قانونياً بذلك، أو", "• إذا كنتم قد وافقتم على ذلك."],
    ],
  },
  {
    number: "7.",
    heading: "النقل إلى دول ثالثة",
    content: ["لا يتم نقل البيانات الشخصية إلى دول خارج الاتحاد الأوروبي أو المنطقة الاقتصادية الأوروبية إلا إذا كان ذلك مسموحاً قانونياً أو وافقتم على ذلك."],
  },
  {
    number: "8.",
    heading: "مدة الاحتفاظ بالبيانات",
    content: ["نحتفظ بالبيانات الشخصية فقط بالقدر الضروري للأغراض المعنية، وكذلك في حالة وجود التزامات قانونية بالاحتفاظ بها وفق قانون التجارة والقانون الضريبي."],
  },
  {
    number: "9.",
    heading: "حقوقكم",
    content: [
      "بموجب اللائحة العامة لحماية البيانات، تتمتعون بالحقوق التالية:",
      [
        "• الحق في الاطلاع (المادة 15)",
        "• الحق في التصحيح (المادة 16)",
        "• الحق في الحذف (المادة 17)",
        "• الحق في تقييد المعالجة (المادة 18)",
        "• الحق في نقل البيانات (المادة 20)",
        "• الحق في الاعتراض (المادة 21)",
        "• الحق في سحب الموافقة بأثر مستقبلي",
        "• الحق في تقديم شكوى لدى سلطة رقابية",
      ],
      "الجهة الرقابية المختصة في ولاية شمال الراين-وستفاليا:",
      [
        "Landesbeauftragte für Datenschutz und Informationsfreiheit NRW",
        "Kavalleriestraße 2–4، 40213 Düsseldorf",
        "الهاتف: 38424-0 211 49+",
        "البريد: poststelle@ldi.nrw.de",
      ],
    ],
  },
  {
    number: "10.",
    heading: "الالتزام بتقديم البيانات",
    content: ["تقديم البيانات الشخصية ليس مطلوباً قانونياً أو تعاقدياً. ومع ذلك، قد لا نتمكن من معالجة استفساركم أو تنفيذ العقد دون بيانات معينة."],
  },
  {
    number: "11.",
    heading: "اتخاذ القرار الآلي",
    content: ["لا يوجد اتخاذ قرار آلي بما في ذلك التحليل التنبؤي (Profiling) وفق المادة 22 من اللائحة العامة."],
  },
  {
    number: "12.",
    heading: "تحديث سياسة الخصوصية",
    content: ["نحتفظ بحق تعديل سياسة الخصوصية هذه عند الاقتضاء بسبب تغييرات قانونية أو تقنية أو تنظيمية."],
  },
];

const DatenschutzPage: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const isAr = currentLanguage === "ar";

  const sections =
    currentLanguage === "ar" ? AR_SECTIONS : currentLanguage === "en" ? EN_SECTIONS : DE_SECTIONS;

  const title =
    currentLanguage === "ar" ? "سياسة الخصوصية" : currentLanguage === "en" ? "Privacy Policy" : "Datenschutzerklärung";

  const overline =
    currentLanguage === "ar" ? "قانوني" : currentLanguage === "en" ? "Legal" : "Rechtliches";

  return (
    <Container maxWidth="md" sx={{ py: 10, dir: isAr ? "rtl" : "ltr" }}>
      <Typography variant="overline" sx={{ color: "text.secondary", letterSpacing: 3, display: "block", mb: 2 }}>
        {overline}
      </Typography>
      <Typography variant="h2" sx={{ mb: 8 }}>
        {title}
      </Typography>

      {sections.map((section, idx) => (
        <Box key={idx} sx={{ mb: 5 }}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 700, color: "#1a2640" }}>
            {section.number} {section.heading}
          </Typography>

          {section.content.map((block, bi) =>
            Array.isArray(block) ? (
              <Box key={bi} sx={{ pl: 2, mb: 1.5 }}>
                {block.map((line, li) => (
                  <Typography key={li} variant="body1" sx={{ color: "text.secondary", lineHeight: 1.8, mb: 0.5 }}>
                    {line}
                  </Typography>
                ))}
              </Box>
            ) : (
              <Typography key={bi} variant="body1" sx={{ color: "text.secondary", lineHeight: 1.8, mb: 1.5 }}>
                {block}
              </Typography>
            )
          )}

          {idx < sections.length - 1 && <Divider sx={{ mt: 4 }} />}
        </Box>
      ))}
    </Container>
  );
};

export default DatenschutzPage;
